import { createCrudService } from '../api/baseService';

const crudService = createCrudService('documenttypes');

export const documentTypeService = {
  ...crudService,
};
